const getDefaultState = () => {
  return {
    clients: [],
    open_modal_client: false,
    client_index: false,
    client: {},
    title_modal_client: '',
    name_client: '',
    identifier_client: '',
    description_client: '',
    color_client: '',
    open_modal_client_destroy: false,
    order_smileys: 'right',
    hidden_logo_knower: false,
  };
};

const state = getDefaultState();


const getters = {
  color_client (state) {
    return state.color_client;
  },
  hidden_logo_knower (state) {
    return state.hidden_logo_knower;
  },
  name_client (state) {
    return state.name_client;
  },
  identifier_client (state) {
    return state.identifier_client;
  },
  description_client (state) {
    return state.description_client;
  },
  client (state) {
    return state.client;
  },
  clients (state) {
    return state.clients;
  },
  client_index (state) {
    return state.client_index;
  },
  open_modal_client (state) {
    return state.open_modal_client;
  },
  open_modal_client_destroy (state) {
    return state.open_modal_client_destroy;
  },
  title_modal_client (state) {
    return state.title_modal_client;
  }
};

const mutations = {
  setColorClient (state, payload) {
    state.color_client = payload;
  },
  setOpenModalClientDestroy (state, payload) {
    state.open_modal_client_destroy = payload;
  },
  setNameClient (state, payload) {
    state.name_client = payload;
  },
  setOrderSmileys (state, payload) {
    state.order_smileys = payload;
  },
  setIdentifierClient (state, payload) {
    state.identifier_client = payload;
  },
  setHiddenLogoKnower (state, payload) {
    state.hidden_logo_knower = payload;
  },
  setDescriptionClient (state, payload) {
    state.description_client = payload;
  },
  setTitleModalClient (state, payload) {
    state.title_modal_client = payload;
  },
  setClient (state, payload) {
    state.client = payload;
  },
  addClient (state, payload) {
    state.clients.push(payload);
  },
  setClients (state, payload) {
    state.clients = payload;
  },
  setClientIndex (state, payload) {
    state.client_index = payload;
  },
  setOpenModalclient (state, payload) {
    state.open_modal_client = payload;
  },
  resetClients (state) {
    Object.assign(state, getDefaultState());
  },
};

const actions = {
  setColorClient (context, payload) {
    context.commit('setColorClient', payload);
  },
  setOrderSmileys (context, payload) {
    context.commit('setOrderSmileys', payload);
  },
  setOpenModalClientDestroy (context, payload) {
    context.commit('setOpenModalClientDestroy', payload);
  },
  setNameClient (context, payload) {
    context.commit('setNameClient', payload);
  },
  setIdentifierClient (context, payload) {
    context.commit('setIdentifierClient', payload);
  },
  setHiddenLogoKnower (context, payload) {
    context.commit('setHiddenLogoKnower', payload);
  },
  setDescriptionClient (context, payload) {
    context.commit('setDescriptionClient', payload);
  },
  setTitleModalClient (context, payload) {
    context.commit('setTitleModalClient', payload);
  },
  setClient (context, payload) {
    context.commit('setClient', payload);
  },
  addClient (context, payload) {
    context.commit('addClient', payload);
  },
  setClients (context, payload) {
    context.commit('setClients', payload);
  },
  setClientIndex (context, payload) {
    context.commit('setClientIndex', payload);
  },
  setOpenModalclient (context, payload) {
    context.commit('setOpenModalclient', payload);
  }
};

export default {
  state,
  mutations,
  getters,
  actions,
};



// WEBPACK FOOTER //
// ./src/store/modules/client.js